module.exports = __webpack_public_path__ + "img/logo.2aca0d9b.png";